// import useBitcoinPrice from "@/hooks/useBitcoinPrice_mempool";
import { useBitcoinPrice } from '@/hooks/api/useBitcoinPrice';

export interface ValidBitcoinPrice {
  price: number;
  timestamp: number;
}

// FIXME: move to hooks
const useValidBitcoinPrice = (): ValidBitcoinPrice | null => {
  const { data: price, isLoading, isError } = useBitcoinPrice();

  if (isLoading || isError || !price || typeof price.USD !== 'number' || !isFinite(price.USD) || Number.isNaN(price.USD)) {
    // console.log(`isLoading=${isLoading}, isError=${isError}, price:`, price);
    return null;
  }

  return {
    price: price.USD,
    timestamp: price.time,
  };
};

export default useValidBitcoinPrice;
